export default __webpack_public_path__ + "static/media/Goose.f2d24bce.png";